import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "cancel-flow-reasons__list" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "cancel-flow-popup__footer" }

import { onMounted } from 'vue'

import AppButton from '@/app/components/button/AppButton.vue'
import { BillingView } from '@/models/billing'
import { ALL_REASONS } from '@/models/billing.cancelFlow'
import type { Reason, ReasonValue } from '@/models/billing.cancelFlow'
import { Mixpanel } from '@/analytics/mixpanel'


export default /*@__PURE__*/_defineComponent({
  __name: 'CancelFlowReasons',
  props: {
    billing: {},
    canceling: { type: Boolean }
  },
  emits: ["reasonSelected", "continueCancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

onMounted(() => {
  Mixpanel.trackCancelFlowStepShown(props.billing, 'reasons')
})

function onReasonClick(reason: Reason): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'reasons',
    'reason',
    reason.value,
  )
  emit('reasonSelected', reason.value)
}

function onEndMembership(): void {
  Mixpanel.trackCancelFlowButtonClick(
    props.billing,
    'reasons',
    'end_membership',
  )
  emit('continueCancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ALL_REASONS), (reason) => {
        return (_openBlock(), _createElementBlock("li", {
          key: reason.value
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "cancel-flow-reasons__item",
            disabled: __props.canceling,
            onClick: ($event: any) => (onReasonClick(reason))
          }, _toDisplayString(reason.label), 9, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(AppButton, {
        danger: true,
        loading: __props.canceling,
        disabled: __props.canceling,
        class: "cancel-flow-popup__cta",
        onClick: onEndMembership
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" End my membership ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "disabled"])
    ])
  ], 64))
}
}

})